<section class="latest-post-section section-gap">
    <div class="container-fluid pl-5 pr-5 text-center">
        <h1 class="titleSectionNoticias">Noticias.</h1>
        <div class="latest-post-loop row mt-50 justify-content-center">
            <div class="col-lg-3 col-md-6 col-10 col-tiny-12" *ngFor="let noticia of modelNoticias, let i = index">
                <div class="latest-post-box">
                    <div class="post-thumb-wrap">
                      <div class="post-thumb">
                        <img src="{{noticia.Imagen}}" style="width: 100%;">
                      </div>
                    </div>
                    <div class="post-desc text-justify">
                        <span class="post-date"><i class="far fa-calendar-alt"></i>{{noticia.Fecha}}</span>
                        <h3 class="title">
                            <a routerLink="/blog-details/{{noticia.idNoticia}}">{{noticia.Titulo | slice:0:45}}... </a>
                        </h3>
                        <p> {{noticia.Descripcion | slice:0:120}}... </p>
                        <div class="post-link" (click)="details(i)">
                            Continuar leyendo <i class="far fa-long-arrow-right"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
